import { Heart, Zap, Activity, Cpu, Stethoscope, ArrowRight } from "lucide-react";

const AREAS = [
  {
    icon: Activity,
    title: "Hipertensión & Arritmias",
    desc: "Control y manejo personalizado de presión arterial y trastornos del ritmo cardíaco.",
  },
  {
    icon: Heart,
    title: "Prevención y tratamiento de Infartos",
    desc: "Evaluación de riesgo cardiovascular, estratificación y plan terapéutico individualizado.",
  },
  {
    icon: Zap,
    title: "Insuficiencia Cardíaca & Marcapasos",
    desc: "Seguimiento de pacientes con disfunción ventricular y dispositivos cardíacos implantables.",
  },
  {
    icon: Stethoscope,
    title: "Valoraciones Preoperatorias",
    desc: "Evaluación cardiológica completa con resultados detallados para tu cirugía en tiempo y forma.",
  },
  {
    icon: Cpu,
    title: "Dislipidemias & Colesterol",
    desc: "Manejo experto del colesterol y triglicéridos basado en investigación publicada por el Dr.",
  },
  {
    icon: Heart,
    title: "Cardiología del Adulto Mayor",
    desc: "Atención cálida, paciente y especializada en personas con movilidad reducida.",
  },
];

export const AreasAtencion = () => {
  return (
    <section id="areas" data-testid="areas-section" className="py-20 md:py-28 bg-[hsl(var(--navy))] text-[hsl(var(--cream))] relative overflow-hidden">
      {/* Subtle decorative grid */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: "linear-gradient(hsl(var(--cream)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--cream)) 1px, transparent 1px)",
        backgroundSize: "48px 48px",
      }} />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="max-w-2xl mb-14">
          <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--soft-red))] font-medium">
            · Áreas de atención especializada ·
          </span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            Padecimientos que
            <br />
            <span className="italic font-light">tratamos a profundidad.</span>
          </h2>
          <p className="mt-5 text-[hsl(var(--cream))]/70 text-base md:text-lg leading-relaxed">
            Lenguaje claro, diagnóstico preciso y un plan de tratamiento que entiendes — siempre.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[hsl(var(--cream))]/10 rounded-2xl overflow-hidden">
          {AREAS.map((a, i) => (
            <div
              key={a.title}
              data-testid={`area-card-${i}`}
              className="group bg-[hsl(var(--navy))] p-7 transition-all hover:bg-[hsl(var(--navy-soft))] cursor-default"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-11 h-11 rounded-lg border border-[hsl(var(--cream))]/15 grid place-items-center group-hover:border-[hsl(var(--soft-red))] group-hover:bg-[hsl(var(--soft-red))]/10 transition-colors">
                  <a.icon className="w-5 h-5 text-[hsl(var(--cream))]" strokeWidth={1.5} />
                </div>
                <ArrowRight className="w-4 h-4 text-[hsl(var(--cream))]/30 group-hover:text-[hsl(var(--soft-red))] group-hover:translate-x-1 transition-all" />
              </div>
              <h3 className="font-serif-display text-xl mb-2">{a.title}</h3>
              <p className="text-sm text-[hsl(var(--cream))]/70 leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
